var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"font-weight-black"},[_vm._v("J-REIT個人投資家アンケート（個別銘柄投資経験あり）")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }